import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const AddStrategies = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.624 9.68481C13.9101 9.54773 14.2531 9.66851 14.3906 9.95435C14.528 10.2407 14.4074 10.5846 14.1211 10.7219L7.83008 13.7385C7.67298 13.8137 7.49009 13.8139 7.33301 13.7385L1.042 10.7219C0.755991 10.5845 0.63531 10.2405 0.772467 9.95435C0.909826 9.66848 1.25298 9.54798 1.53907 9.68481L7.58106 12.5813L13.624 9.68481ZM11.5693 6.5979C11.7057 6.31125 12.0492 6.18935 12.3359 6.32544L14.0381 7.13501C14.238 7.2302 14.3658 7.43213 14.3662 7.65356C14.3665 7.87501 14.2388 8.07733 14.0391 8.1731L7.74903 11.1897C7.59192 11.2649 7.40805 11.265 7.25098 11.1897L0.959967 8.1731C0.759969 8.07692 0.632778 7.87356 0.633795 7.65161C0.634891 7.42955 0.764763 7.22727 0.965826 7.13306L2.6963 6.32349C2.98382 6.18908 3.32632 6.31344 3.46094 6.60083C3.59548 6.88846 3.47121 7.23091 3.1836 7.36548L2.55176 7.6604L7.50001 10.0325L12.457 7.65552L11.8418 7.36353C11.5554 7.22705 11.4332 6.88449 11.5693 6.5979ZM7.4961 0.900635C7.81364 0.900635 8.07126 1.15829 8.0713 1.47583V4.20337H10.6748C10.9923 4.20348 11.25 4.46109 11.25 4.77856C11.25 5.09604 10.9923 5.35365 10.6748 5.35376H8.0713V7.95142C8.0711 8.26882 7.81355 8.52563 7.4961 8.52563C7.17909 8.52512 6.92207 8.2685 6.92188 7.95142V5.35376H4.33692C4.01978 5.35329 3.76273 5.09581 3.7627 4.77856C3.76273 4.46132 4.01978 4.20384 4.33692 4.20337H6.92188V1.47583C6.92191 1.15861 7.17899 0.901147 7.4961 0.900635Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default AddStrategies
